import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import AdminModal from '../AdminModal.js';
import AdminDetailList from '../AdminDetailList.js';

const DeleteTeamModal = ({ isOpen, onClose, onConfirm, team, loading }) => (
  <AdminModal
    isOpen={isOpen && !!team}
    onClose={onClose}
    title="Delete Team"
    actions={(
      <>
        <button className="cancel-button" onClick={onClose} disabled={loading}>
          Cancel
        </button>
        <button className="admin-submit-button" onClick={onConfirm} disabled={loading}>
          {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Delete Team'}
        </button>
      </>
    )}
  >
    <p style={{ color: '#d32f2f', fontWeight: 'bold' }}>
      Are you sure you want to delete this team? This action cannot be undone.
    </p>
    <AdminDetailList
      rows={[
        { label: 'Team Name:', value: team?.teamName },
        { label: 'Members:', value: team?.userIds?.length || 0 },
      ]}
    />
    <p style={{ marginTop: '15px', color: '#666', fontSize: '14px' }}>
      Team members will no longer be associated with this team.
    </p>
  </AdminModal>
);

export default DeleteTeamModal;
